export default __webpack_public_path__ + "static/Vulcain_LP2_Hero-234c128fd758d5a3f7c6a65911853958.png";